<ion-content class="ion-text-center">
  <div class="centered-max-width">
    <img src="/assets/img/undraw_page_not_found.svg" height="250" width="376.484" class="ion-margin-vertical no-background" />
    <p>Unfortunately the page you were looking for was not found</p>
    <ion-button color="primary" (click)="goBack()">Go back</ion-button>
  </div>
</ion-content>
